define("shared/utils/formatters/caption-from-regram", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Formats caption text from IG post to also include mediaSource and username
   */
  const formatRegramCaption = _ref => {
    let {
      caption = '',
      username = '',
      link = '',
      commentText = '',
      commentUsername = ''
    } = _ref;
    const mediaSource = `Media Source: ${link}`;
    const postCredit = username ? `( #📷 @${username} )` : '';
    const commentCredit = commentText ? `${commentText} (@${commentUsername})` : commentUsername;
    return [mediaSource, `${caption} ${postCredit}`.trim(), commentCredit].filter(i => i).join('\n\n');
  };
  var _default = _exports.default = formatRegramCaption;
});